export const REQUEST_AUTHENTICATED = 'REQUEST_AUTHENTICATED';
export const AUTHENTICATED_USER = 'AUTHENTICATED_USER';
export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const AUTHENTICATED_ERROR = 'AUTHENTICATED_ERROR';
export const SHOULD_RESET_PASSWORD = 'SHOULD_RESET_PASSWORD';
